import { useState } from "preact/hooks";

import { fetchScanStatus, setToken } from "../lib/api";

interface Props {
  onUnlocked: () => void;
}

export function TokenGate({ onUnlocked }: Props) {
  const [value, setValue] = useState("");
  const [showValue, setShowValue] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);

  async function submit(e: Event) {
    e.preventDefault();
    const trimmed = value.trim();
    if (!trimmed) {
      setError("Enter the dashboard password.");
      return;
    }

    setSubmitting(true);
    setError(null);
    setToken(trimmed);

    try {
      await fetchScanStatus();
      onUnlocked();
    } catch (err) {
      setToken("");
      setError(err instanceof Error ? err.message : "Invalid dashboard password.");
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div class="token-gate">
      <div class="token-gate-card smoke-card">
        <h2>Dashboard password</h2>
        <p class="form-hint">
          Enter the password for this job tracker. You only need to do this once on this device.
        </p>
        <form onSubmit={submit}>
          <div class="form-group">
            <label for="dashboard-token">Password</label>
            <div class="token-input-row">
              <input
                id="dashboard-token"
                type={showValue ? "text" : "password"}
                class="form-control"
                value={value}
                onInput={(e) => setValue(e.currentTarget.value)}
                placeholder="Dashboard password"
                autoComplete="current-password"
                disabled={submitting}
              />
              <button
                type="button"
                class="platform-btn"
                onClick={() => setShowValue((v) => !v)}
                aria-label={showValue ? "Hide password" : "Show password"}
              >
                {showValue ? "Hide" : "Show"}
              </button>
            </div>
          </div>
          {error && <p class="form-error">{error}</p>}
          <button type="submit" class="platform-btn active" disabled={submitting}>
            {submitting ? "Checking…" : "Continue"}
          </button>
        </form>
      </div>
    </div>
  );
}
